export default {
  title: 'SEO',
  subtitle:
    'Pas de titel en beschrijving aan die verschijnen in Google-zoekresultaten en sociale voorbeelden. Laat leeg om de standaardwaarden te gebruiken.',
  fields: {
    title: {
      label: 'Paginatitel',
      placeholder: 'bijv. Forza Napoli — authentieke Napolitaanse pizza in München',
      help: 'Wordt weergegeven als kop in Google-resultaten en browsertabbladen. Maximaal 255 tekens; streef naar 50–60 voor de beste weergave.',
    },
    description: {
      label: 'Meta-beschrijving',
      placeholder: 'Korte samenvatting van uw restaurant die onder de titel in zoekresultaten verschijnt.',
      help: 'Maximaal 500 tekens; Google toont doorgaans 150–160. Benadruk wat uw restaurant uniek maakt.',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    saved: 'SEO-instellingen opgeslagen',
    failed: 'SEO-instellingen opslaan mislukt',
  },
};
